import { MenuItem } from '../models/menu-item.model';
import { Permissions } from '../enums/permissions.enum';

export const MENU_ITEMS: MenuItem[] = [
  // {
  //   label: 'My Profile',
  //   icon: 'bi-person-circle',
  //   route: '/dashboard/doctor-profile',
  //   permission: Permissions.BILLING,
  // },

  {
    label: 'Team Chat',
    icon: 'bi-chat-dots-fill',
    route: '/dashboard/staff-chat',
    permission: Permissions.SCHEDULING,
  },

  // --- Manager routes ---
];
